module.exports = __webpack_public_path__ + "img/close-image.ba58896a.svg";